import React from 'react'

const EmailCompose = () => {
  return (
    <div>
         <h1><center>Coming Soon...</center></h1>
    </div>
  )
}

export default EmailCompose